import { sendGtmEvent } from "~/analytics/definitions";

interface SendSearchABVariationGtmEventProps {
  isScannEligible: boolean;
  scannItemsCount: number;
  abTest: string;
}

const sendSearchABVariationGtmEvent = ({
  isScannEligible,
  scannItemsCount,
  abTest,
}: SendSearchABVariationGtmEventProps) => {
  let abTestValue = "search_scann_v3";

  if (abTest === "soon") {
    abTestValue = "search_scann_v4";
  }

  sendGtmEvent({
    event: "Search_AB_Test",
    eventLabel: `${isScannEligible ? 1 : 0}_${scannItemsCount}_${abTestValue}`,
    eventAction: "Search Impression",
  });
};

export default sendSearchABVariationGtmEvent;
